import { getLocalStorage, setLocalStorage } from "./functions";

/**
 * Make types available in JSDocs without importing them since this is not a TS file.
 *
 * @import { UserType } from "../form_features";
 */

export default class UserTypeStorage {
    
    /**
     * @returns {UserType}
     */
    static getUserType() {
        return getLocalStorage('userSettings')?.userType;
    }

    /**
     * @param {UserType} userType
     */
    static setUserType(userType) {
        const settings = getLocalStorage('userSettings') ?? {};
        settings.userType = userType;
        setLocalStorage('userSettings', settings);
    }
}
